import styled, { css } from 'styled-components';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { MEDIA_QUERY, useFullWidthOnSmallCss } from '../../fundamentals/breakpoints/breakpoints';
import React, { ReactElement } from 'react';
import { IButtonProps } from '../Button/Button';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { ResponsiveGapContainer } from '../../fundamentals/spaces/responsive/SpaceContainerResponsive';
import { IGapProps, useColumnGapCss } from '../../fundamentals/spaces/space';
import { IResponsiveGutterProps } from '../../fundamentals/spaces/responsive/spaceResponsive';

export interface ICtaButtonBarProps extends IGapProps, IResponsiveGutterProps {
  ctaButtons?: ReactElement<IButtonProps> | ReactElement<IButtonProps>[];
  ctaFullOnMobile?: boolean;
}

const Container = styled(ResponsiveGapContainer)<Pick<ICtaButtonBarProps, 'ctaFullOnMobile'> & IGapProps>`
  ${({ gap }) => {
    return (
      typeof gap === 'number' &&
      css`
        ${useColumnGapCss()};
      `
    );
  }};

  align-items: center;
  flex-wrap: wrap;

  ${({ theme, ctaFullOnMobile = true }) =>
    ctaFullOnMobile
      ? css`
          flex-direction: column;
          ${useFullWidthOnSmallCss}
          ${theme.mediaQueries[MEDIA_QUERY.MIN][SIZES.SMALL]} {
            flex-direction: row;
          }
        `
      : css`
          flex-direction: row;
        `}
`;

export const CtaButtonBar = styled(({ ctaButtons, ...rest }: ICtaButtonBarProps) => {
  const { generateTestId } = useTestId(rest, 'CtaButtonBar');

  if (!ctaButtons) {
    return <></>;
  }

  return (
    <Container gap={'medium'} {...generateTestId()} {...rest}>
      {ctaButtons}
    </Container>
  );
})<ICtaButtonBarProps>``;
